import { K8sProviderIcon } from '@cast/features-cluster-ui';

import {
  Button,
  DialogActions,
  DialogContent,
  HexIcon,
  CloseDialogButton,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type SuccessSlideProps = {
  onClose: () => void;
  onCreateEdgeLocationClick?: () => void;
};

export const SuccessSlide = ({
  onClose,
  onCreateEdgeLocationClick,
}: SuccessSlideProps) => {
  const { cluster } = useCluster();

  return (
    <Stack position="relative" data-testid="success-slide">
      <CloseDialogButton onClose={onClose} />
      <DialogContent>
        <Stack direction="row" alignItems="center" gap={12}>
          <HexIcon variant="success" size={50} />
          <Typography variant="h6" display="flex" alignItems="center" gap={4}>
            Great!
            <K8sProviderIcon provider={cluster.providerType} size={18} />
            {cluster.name} extended successfully!
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{ py: 16, borderTop: tokens.theme.border.structural.neutralSubtle }}
      >
        <Button onClick={onClose} variant="secondary" testId="close-button">
          Close
        </Button>
        {onCreateEdgeLocationClick && (
          <Button
            testId="create-edge-location-button"
            onClick={() => {
              onClose();
              onCreateEdgeLocationClick();
            }}
            variant="primary"
          >
            Create edge location
          </Button>
        )}
      </DialogActions>
    </Stack>
  );
};
